/* TODO: Remove in next releas 6.1.1 */
import { ActionCardItemRenderProps, RenderType } from '@graphcommerce/next-ui'
import { ConfigurableOptionValueColor } from '@graphcommerce/magento-product-configurable/components/ConfigurableOptionValueColor'
import { ConfigurableOptionValueImage } from '@graphcommerce/magento-product-configurable/components/ConfigurableOptionValueImage/ConfigurableOptionValueImage'
import { ConfigurableOptionValueText } from './ConfigurableOptionValueText'
import { ConfigurableOptionValueFragment } from '@graphcommerce/magento-product-configurable/components/ConfigurableOptionValue/ConfigurableOptionValue.gql'
import {lighten} from '@mui/material'

export type ConfigurabeOptionValueProps = ActionCardItemRenderProps<ConfigurableOptionValueFragment>

export function ConfigurableOptionValue(props: ConfigurabeOptionValueProps) {
  const { swatch_data } = props

  return (
    <RenderType
      {...props}
      __typename={swatch_data?.__typename ?? 'TextSwatchData'}
      description={swatch_data?.value ?? ''}
      renderer={{
        ColorSwatchData: ConfigurableOptionValueColor,
        ImageSwatchData: ConfigurableOptionValueImage,
        TextSwatchData: ConfigurableOptionValueText,
      }}
    />
  )
}
